<template>
  <div class="row">
    <div class="col">
      <div v-for="(item, index) in treeData" :key="index">
        <TreeNode :node="item" :level="0"></TreeNode>
      </div>
    </div>

    <div class="col">
      <Tags :data="tagsData">
      </Tags>
    </div>
    <LoadingOverlay :isLoading="!hydrated"/>
  </div>
</template>

<script>
import TreeNode from "./navigation/TreeNode.vue";
import Tags from "./navigation/Tags.vue";
import LoadingOverlay from "./shared/LoadingOverlay.vue";

export default {
  name: "Navigation",
  data() {
    return {
      treeData: [],
      tagsData: [],
      hydratedTree: false,
      hydratedTags: false,
    }
  },
  computed: {
    hydrated() {
      return this.hydratedTree && this.hydratedTags;
    }
  },
  components: {
    TreeNode,
    Tags,
    LoadingOverlay
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      // Load tree data
      try {
        const treeResponse = await fetch('/api/navigation/tree');
        if (!treeResponse.ok) {
          throw new Error(`HTTP error! status: ${treeResponse.status}`);
        }
        const treeData = await treeResponse.json();
        this.treeData = treeData;
        this.hydratedTree = true;
      } catch (error) {
        console.error('Failed to load tree data:', error);
        this.treeData = [];
        this.hydratedTree = true;
      }
      
      // Load tags data
      try {
        const tagsResponse = await fetch('/api/navigation/tags');
        if (!tagsResponse.ok) {
          throw new Error(`HTTP error! status: ${tagsResponse.status}`);
        }
        const tagsData = await tagsResponse.json();
        this.tagsData = tagsData;
        this.hydratedTags = true;
      } catch (error) {
        console.error('Failed to load tags data:', error);
        this.tagsData = [];
        this.hydratedTags = true;
      }
    },
  },
};
</script>
